export const COOKIE_PATH_KEY = "sph-epaper-cookie-path";

/**
 * Saves the path LB2 scopes the mySPH session cookies to.
 *
 * Pass the publication id whenever it is known: the reader
 * (/{pubId}/ccidist-replica-reader/) and the BFF (/{pubId}/api/*) only
 * receive cookies scoped to /{pubId}, so on the single-flavor pages
 * (/zb-single, /tm-single, /sm-single) saving the page path leaves them
 * unauthenticated (IRISX-42).
 *
 * Without an argument, falls back to the first path segment of the
 * current URL.
 */
export const saveCookiePath = (pubId?: string) => {
  if (pubId) {
    localStorage.setItem(COOKIE_PATH_KEY, `/${pubId}`);
    return;
  }

  const currentUrlPath = new URL(window.location.href).pathname;
  const split = currentUrlPath.split("/");

  if (split.length < 2 || split[1] === "") {
    console.error(
      "Cannot extract cookie path from current URL - URL has no path segments.",
    );
  }

  const cookiePath = `/${split[1]}`;
  localStorage.setItem(COOKIE_PATH_KEY, cookiePath);
};
